import { mapActions, mapState } from 'vuex';
import pendingRequestDeposit from '@/components/wallet/pending-requests/pending-request-deposit/pending-request-deposit.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import alertBox from '@/components/generics/alert-box/alert-box.vue';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    alertBox,
    pendingRequestDeposit,
  },
  created() {
    this.getPendingDeposits().then(() => {
      this.isComponentReady = true;
    });
  },
  computed: {
    ...mapState('wallet', ['pendingDepositsRequests']),
  },
  methods: {
    ...mapActions('wallet', ['getPendingDeposits']),
    onComplete() {
      this.getPendingDeposits();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-requests-list-deposit/pending-requests-list-deposit.js